import LegalLayout from './LegalLayout';
import Seo from '../components/Seo';

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Gizlilik Politikası">
      <Seo
        title="Gizlilik Politikası | Mahallebi"
        description="Mahallebi gizlilik politikası: hangi kişisel veriler toplanır, nasıl kullanılır, saklanır ve korunur."
        path="/privacy"
      />
      <p className="text-sm text-gray-500 mb-6">Son güncelleme: 29 Mart 2026</p>

      <p className="mb-6">
        UBS Bilişim Teknolojileri ("Şirket") olarak, Mahallebi platformunu kullanan kullanıcılarımızın
        gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, kişisel verilerinizin nasıl toplandığını,
        kullanıldığını, saklandığını ve korunduğunu açıklamaktadır.
      </p>

      <Section title="1. Toplanan Kişisel Veriler">
        <p className="mb-3">Platformumuz aşağıdaki kişisel verileri toplamaktadır:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Kimlik verileri:</strong> Ad, soyad, kullanıcı adı, profil fotoğrafı</li>
          <li><strong>İletişim verileri:</strong> E-posta adresi, telefon numarası</li>
          <li><strong>Konum verileri:</strong> GPS koordinatları, mahalle, ilçe ve il bilgisi (izninizle)</li>
          <li><strong>Kullanım verileri:</strong> İlan geçmişi, arama kayıtları, beğeniler, kaydedilenler</li>
          <li><strong>Cihaz verileri:</strong> Cihaz modeli, işletim sistemi, uygulama sürümü</li>
          <li><strong>İletişim içerikleri:</strong> Platform üzerinden gönderilen mesajlar</li>
          <li><strong>İşlem güvenliği verileri:</strong> IP adresi, giriş/çıkış kayıtları, oturum bilgileri</li>
        </ul>
      </Section>

      <Section title="2. Verilerin Toplanma Yöntemi">
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Doğrudan:</strong> Kayıt olurken, profil düzenlerken, ilan oluştururken sağladığınız bilgiler</li>
          <li><strong>Otomatik:</strong> Platformu kullanırken cihazınızdan otomatik olarak toplanan teknik veriler</li>
          <li><strong>Üçüncü taraf:</strong> Google OAuth ile giriş yaptığınızda Google tarafından paylaşılan temel profil bilgileri</li>
        </ul>
      </Section>

      <Section title="3. Verilerin Kullanım Amaçları">
        <ul className="list-disc pl-6 space-y-2">
          <li>Hesap oluşturma ve kimlik doğrulama</li>
          <li>Konum bazlı ilan gösterimi ve komşu eşleştirmesi</li>
          <li>Acil yardım taleplerinin yakındaki kullanıcılara iletilmesi</li>
          <li>Güven puanı hesaplama ve rozet sistemi</li>
          <li>Platform güvenliğini sağlama ve kötüye kullanımı önleme</li>
          <li>İçerik moderasyonu ve spam tespiti</li>
          <li>Kullanıcı deneyimini iyileştirme ve analiz</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
          <li>Push bildirimleri ve uygulama içi bildirimler gönderme</li>
        </ul>
      </Section>

      <Section title="4. Verilerin Paylaşımı">
        <p className="mb-3">Kişisel verileriniz aşağıdaki durumlarda üçüncü taraflarla paylaşılabilir:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Hizmet sağlayıcıları:</strong> Supabase (veritabanı), Cloudflare (CDN), Sentry (hata izleme), Twilio (SMS doğrulama)</li>
          <li><strong>Diğer kullanıcılar:</strong> Profilinizde görünmesini tercih ettiğiniz bilgiler (ad, mahalle, güven puanı)</li>
          <li><strong>Yasal zorunluluk:</strong> Mahkeme kararı veya yasal talep halinde yetkili makamlara</li>
        </ul>
        <p className="mt-3">Kişisel verileriniz hiçbir koşulda reklam amacıyla üçüncü taraflarla paylaşılmaz veya satılmaz.</p>
      </Section>

      <Section title="5. Veri Güvenliği">
        <ul className="list-disc pl-6 space-y-2">
          <li>Tüm veriler HTTPS/TLS şifreleme ile aktarılır</li>
          <li>Veritabanı erişimi Row Level Security (RLS) ile korunur</li>
          <li>Şifreler hash'lenerek saklanır, düz metin olarak tutulmaz</li>
          <li>Düzenli güvenlik denetimleri ve güncellemeler yapılır</li>
          <li>Çalışan erişimi minimum yetki prensibiyle sınırlandırılır</li>
        </ul>
      </Section>

      <Section title="6. Çerezler ve Benzer Teknolojiler">
        <p>
          Platform, oturum yönetimi ve kullanıcı tercihlerinin saklanması için localStorage ve
          oturum çerezleri kullanır. Üçüncü taraf izleme çerezleri kullanılmaz. Analitik verileri
          anonim olarak toplanır.
        </p>
      </Section>

      <Section title="7. Veri Saklama Süresi">
        <ul className="list-disc pl-6 space-y-2">
          <li>Hesap bilgileri: Hesap aktif olduğu sürece</li>
          <li>İlan verileri: İlan süresi + 6 ay</li>
          <li>Mesaj geçmişi: 2 yıl</li>
          <li>İşlem güvenliği logları: 1 yıl</li>
          <li>Hesap silme sonrası: 30 gün içinde anonimleştirilir</li>
        </ul>
      </Section>

      <Section title="8. Haklarınız">
        <p className="mb-3">KVKK ve GDPR kapsamında aşağıdaki haklara sahipsiniz:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Kişisel verilerinize erişim talep etme</li>
          <li>Yanlış veya eksik verilerin düzeltilmesini isteme</li>
          <li>Verilerinizin silinmesini talep etme (unutulma hakkı)</li>
          <li>Veri işlemeye itiraz etme</li>
          <li>Veri taşınabilirliği talep etme</li>
          <li>Otomatik karar alma süreçlerine itiraz etme</li>
        </ul>
        <p className="mt-3">
          Bu haklarınızı kullanmak için uygulama içi Ayarlar &gt; Gizlilik bölümünden veya
          aşağıdaki iletişim bilgilerinden bize ulaşabilirsiniz.
        </p>
      </Section>

      <Section title="9. Çocukların Gizliliği">
        <p>
          Platform 18 yaş altındaki bireylere yönelik değildir. 18 yaşından küçük bir bireye ait
          kişisel verilerin toplandığını fark edersek, bu verileri derhal sileriz.
        </p>
      </Section>

      <Section title="10. Politika Değişiklikleri">
        <p>
          Bu Gizlilik Politikası gerektiğinde güncellenebilir. Önemli değişiklikler uygulama içi
          bildirim ve/veya e-posta ile kullanıcılara duyurulur.
        </p>
      </Section>

      <Section title="11. İletişim">
        <p className="mb-2">Gizlilik ile ilgili tüm soru ve talepleriniz için:</p>
        <ul className="list-none space-y-1">
          <li><strong>Veri Sorumlusu:</strong> UBS Bilişim Teknolojileri</li>
          <li><strong>E-posta:</strong>{' '}
            <a href="mailto:info@ubsbilisim.com" className="text-[#e77e23] hover:underline">info@ubsbilisim.com</a>
          </li>
          <li><strong>Web:</strong>{' '}
            <a href="https://www.ubsbilisim.com" target="_blank" rel="noopener noreferrer" className="text-[#e77e23] hover:underline">www.ubsbilisim.com</a>
          </li>
        </ul>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-[#111827] mb-3">{title}</h2>
      {children}
    </section>
  );
}
